module.exports = __webpack_public_path__ + "img/Pattern-secondary.5dab2fc4.svg";